// Shared marketing section: common questions. Used by Landing and Subscribe.
const FAQS = [
  { q: 'What happens after my free trial?', a: 'Your maps stay saved. Subscribe to keep creating new ones, or access your existing work in read-only mode.' },
  { q: 'Can I cancel anytime?', a: 'Yes. You keep full access through the end of your paid year. No questions asked.' },
  { q: 'What if I need help?', a: 'Reach us at rc@braincentricdesign.com. We respond within one business day.' },
];

export default function Faq() {
  return (
    <div className="max-w-lg w-full mb-12">
      <p className="text-sm font-heading font-bold uppercase tracking-widest text-gray-300 text-center mb-8">
        Common Questions
      </p>
      <div className="space-y-2">
        {FAQS.map(({ q, a }) => (
          <div key={q} className="bg-navy-light rounded-lg px-6 py-4">
            <p className="text-white text-base font-semibold mb-1">{q}</p>
            <p className="text-gray-300 text-sm leading-relaxed">{a}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
